import type { GetStaticProps } from "next"
import type { MDXRemoteSerializeResult } from "next-mdx-remote"
import Container from "@/components/common/Container"
import Layout from "@/components/common/Layout"
import { PageMeta } from "@/components/common/Seo/PageMeta"
import MDXRenderer from "@/components/utils/mdx/MDXRenderer"
import { getLegalPageMdx } from "@/utils/legal-mdx"

interface TermsPageProps {
  mdxSource: MDXRemoteSerializeResult
}

export const getStaticProps: GetStaticProps<TermsPageProps> = async () => {
  const mdxSource = await getLegalPageMdx("terms")
  return { props: { mdxSource } }
}

export default function TermsPage({ mdxSource }: TermsPageProps) {
  return (
    <Layout>
      <PageMeta
        meta={{
          title: "Terms of service",
          description:
            "Read the terms of service for the Token Terminal website, subscriptions, data, API and other products. Contact us if you have questions about these terms.",
        }}
      />
      <div className="py-12 max-w-3xl mx-auto">
        <Container>
          <MDXRenderer mdxSource={mdxSource} />
        </Container>
      </div>
    </Layout>
  )
}
